<template>
    <div v-if="!showMenu & showMenu != 'undefined'">



        <!-- Page Content -->
        <div id="page-content-wrapper">

            <div>
                  <b-button v-b-toggle.sidebar-1 class="btn-menu" style="z-index: 999;"><div class="text"> Menu <b-icon icon="chevron-double-up" class="iconMenu "></b-icon></div></b-button>
                <b-sidebar id="sidebar-1" title="" shadow sidebar-class="bg-menu" bg-variant="bg-menu"
                    text-variant="light">
                  
                    <div class="text-center">
                        <img rounded="circle"  :src="currenUser.ProfileImgUrl ? currenUser.ProfileImgUrl : '../img/user-profile.png'" alt="User image"
                            class="user-Iocn rounded circle" />
                        <p>{{currenUser ? currenUser.FirstNameEN : ''}} {{currenUser? currenUser.LastNameEN : ''}}</p>

                    </div>
                    <!-- applicant menu start -->
                    <div v-if="!currenUser.LoginInfo">
                    <div class="px-3 py-2 row">

                                  <div class="col-md-6">
                            <b-link href="#" to="/dataapp">
                                <div class="menu-item Eventbg">
                                    <b-icon icon="display-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Data</span>

                                </div>
                            </b-link>
                        </div>

                        
                        <div class="col-md-6">
                            <b-link href="#" to='/wallet'>
                                <div class="menu-item Walletbg">
                                    <b-icon icon="wallet2" class=" rounded text-center"></b-icon><br />
                                    <span class="small"> Wallet</span>

                                </div>
                            </b-link>
                        </div>
                   
                        <div class="col-md-6">
                            <b-link href="#" to="/Exam">
                                <div class="menu-item exambg">
                                    <b-icon icon="info-circle-fill" class=" rounded text-center" ></b-icon><br />
                                    <span class="small"> Exams</span>
                                </div>
                            </b-link>
                        </div>

                          <div class="col-md-6">
                            <b-link href="#" to="/tasks">
                                <div class="menu-item Gradesbg">
                                    <b-icon icon="star-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small"> Tasks </span>

                                </div>
                            </b-link>
                        </div>
              
                        
                    
                      <div class="col-md-6">
                            <b-link href="#" to="/Mail">
                                <div class="menu-item Schedulebg">
                                    <b-icon icon="clock" class=" rounded text-center"></b-icon><br />
                                    <span class="small"> Inbox </span>

                                </div>
                            </b-link>
                        </div>


                        <div class="col-md-6">
                            <b-link href="#" to="/Profile">
                                <div class="menu-item Resturantbg">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Profile</span>

                                </div>
                            </b-link>
                        </div>

                        
                        
                   
                                <div class="col-md-6">
                            <b-link href="#" to="/Dorms">
                                <div class="menu-item Roombg">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Dorms</span>

                                </div>
                            </b-link>
                        </div>
                                <div class="col-md-6">
                            <b-link href="#" to="/Transportation">
                                <div class="menu-item Transportationbg">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">Transportation</span>

                                </div>
                            </b-link>
                        </div>
                        
                         </div>
                         </div>
                        <!-- end Applicant menu-->
                        <!-- <div v-if="currenUser.LoginInfo">
                            <div class="px-3 py-2 row" >
                        <div class="col-md-6" v-for="(menu,index) in currenUser.LoginInfo" v-bind:key="index">
                            <b-link href="#" :to="menu.ViewURL">
                                <div class="menu-item" :class="menu.ViewIcon">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="small">{{menu.ViewName}}</span>

                                </div>
                            </b-link>
                        </div>
                   
                                
                            </div>
                        </div> -->
                   
                    <div v-if="currenUser.LoginInfo">
          <div class="px-3 py-2 row">
            <div
              class="col-md-6 col-sm-6"
              v-for="(menu, index) in currenUser.LoginInfo"
              v-bind:key="index"
            >
              <b-link
                href="#"
                :to="menu.ViewURL"
                class=""
                @click="setActive(index)"
              >
                <div
                  class="menu-item"
                  :class="activeTab == index ? 'active' : ''"
                >
                  <b-icon
                    v-bind:icon="menu.ViewIcon"
                    class="rounded text-center"
                  ></b-icon
                  ><br />
                  <span class="">{{ menu.ViewName }}</span>
                </div>
              </b-link>
            </div>
          </div>
        </div>

                    <hr/>
                    <div class="text-center">
                    <button class="btn btn-primary text-center"  @click.prevent="logOut"> Logout <b-icon-lock-fill></b-icon-lock-fill></button>
                    </div>

                </b-sidebar>
            </div>



        </div>
    </div>


</template>

<script>
    export default {


        components: {

        },
        data() {
            return {
               ShowMenu:true,
               activeTab:localStorage.getItem("activeTab") != null
          ? parseInt(localStorage.getItem("activeTab"))
          : 0,
            }
        },
        computed: {
            currenUser() {
                return this.$store.state.auth.user
            },
            showMenu(){
                 return this.$store.state.auth.Menuhide
            }

        },
        mounted() {
        this.showMenu
        },
        methods: {
            logOut() {
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
    },
    Menu(){
        this.showMenu
    },setActive(index) {
      this.activeTab = index;
      localStorage.setItem("activeTab", index);
    },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .btn-menu {
        cursor: pointer;
        height: 140px !important;
        width: 40px !important;
        font-size: 18px;
        position: absolute;
        left: 0 !important; 
        background: #F2B36D;
        color: #285475;
        font-weight: bold;
        text-align: center;
    
  
            border-radius: 0px 10px 10px 0px;
    padding-top: 20px;
      

    }
    .text{
  -ms-transform: rotate(270deg); /* IE 9 */
  transform: rotate(270deg);
    }

    button[aria-expanded="true"]{
  left: 320px !important; 
    transition: all 0.5s ease 0s;
  -webkit-transition: all 0.5s ease 0s;
  position:fixed;
   
}

    button[aria-expanded="false"]{
  left: 0px !important; 
  transition: 0.37s;
   
}

.b-sidebar{
       transition: all 0.9s ease 0s !important;
  -webkit-transition: all 0.9s ease 0s !important;
}
    button.not-collapsed{
        left: 320 !important; 
    }

    .user-Iocn {
        width: 100px;
        height: 100px;
            border-radius: 50% !important;

    }

    .bg-menu {
        background-color: #144163 !important;
        color: #fff !important;
    }

    .bg-dark {
        background-color: #0080ff !important;
    }

    .menu-item {
        border-radius: 10px;
        border-bottom: 1px solid #b2b2b2;
        margin-bottom: 10px;

        /* background:url('https://picsum.photos/500/500/?image=54');*/
        padding: 15px;

        font-size: 1.5rem;
        text-align: center;
    }

    a .menu-item {
        color: #fff;
        text-decoration: none !important
    }

    .exambg {
        background: url('../assets/Exam.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Walletbg {
        background: url('../assets/wallet.png');
        background-repeat: no-repeat;
        background-size: cover;
    }
    .Schedulebg {
        background: url('../assets/Schedule.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Notificationsbg {
        background: url('../assets/Notifications.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Gradesbg {
        background: url('../assets/Grades.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Resturantbg {
        background: url('../assets/Resturant.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    .Transportationbg {
        background: url('../assets/Transportation.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

      .Militarybg {
        background: url('../assets/military.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Ticketbg {
        background: url('../assets/Ticket.png');
        background-repeat: no-repeat;
            background-size: cover;
    }
     .homebg {
        background: url('../assets/bg-body.jpg');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Resturantbg {
        background: url('../assets/Resturant.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Roombg {
        background: url('../assets/Room.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .Eventbg {
        background: url('../assets/Event.png');
        background-repeat: no-repeat;
            background-size: cover;
    }

    .b-sidebar-body {
        overflow-x: hidden !important;
    }

    .smallest {
        font-size: 57%;
        font-weight: 400;
    }
.b-sidebar > .b-sidebar-body {
    overflow-x: hidden !important;
    }
@media only screen and (max-width: 700px){
    .exambg {
background-position: center !important;
border: 1px solid #eee;
    }
 .Walletbg {
background-position: center !important;
border: 1px solid #eee;
    }
     .Eventbg {
background-position: center !important;
border: 1px solid #eee;
    }
     .Schedulebg {
background-position: center !important;
border: 1px solid #eee;
    }
         .Gradesbg {
background-position: center !important;
border: 1px solid #eee;
    }
}
 .iconMenu{
         padding-right: 2px;
    position: absolute;
    left: -28px;
    top: 2px;
 }

 .menu-item {
    border-radius: 10px;
    border: 2px solid #ff8600;
    /* background: url(https://picsum.photos/500/500/?image=54); */
    padding: 5px;
    font-size: 1rem;
    text-align: center;
    color: #295677;
    min-width: 100px;
    min-height: 78px;
    background-image: none;
    background: #fff;
    -o-object-fit: fill;
    object-fit: fill;
    -webkit-box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%), 0 6px 20px 0 rgb(0 0 0 / 8%);
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%), 0 6px 20px 0 rgb(0 0 0 / 8%);
}

.menu-item {
  text-shadow: none !important;
}

a .menu-item {
  color: #295677;
  text-decoration: none !important;
  font-weight: bold;
}

.active {
  color: #fff !important;
  background-color: #144163 !important;
}

</style>

